Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reduxOrm=require('redux-orm');
var _utils=require('./utils');
var _fields=require('redux-orm/lib/fields');
var _armStateData=require('../armState/armStateData');
var _powerStateData=require('../armState/powerStateData');
var _healthStateData=require('../healthStatus/healthStateData');
var _comlianceStateData=require('../complianceState/comlianceStateData');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_POSITIONS:'UPSERT_POSITIONS',
UPDATE_POSITIONS:'UPDATE_POSITIONS',
UPDATE_POSITION:'UPDATE_POSITION',
DELETE_POSITION:'DELETE_POSITION'};var





Position=function(_Model){_inherits(Position,_Model);function Position(){_classCallCheck(this,Position);return _possibleConstructorReturn(this,(Position.__proto__||Object.getPrototypeOf(Position)).apply(this,arguments));}_createClass(Position,[{key:'isLock',value:function isLock()




























































{
return this.securityDeviceId&&this.securityDeviceId.isLock();
}},{key:'getArmStateData',value:function getArmStateData()

{
var device=this.securityDeviceId;
return(0,_armStateData.armStateDataForDevice)(device);
}},{key:'getHealthStateData',value:function getHealthStateData()

{
return(0,_healthStateData.healthStateData)(this);
}},{key:'getComplianceStateData',value:function getComplianceStateData()

{
return(0,_comlianceStateData.positionComplianceStateData)(this);
}},{key:'getPowerStateData',value:function getPowerStateData()

{
var device=this.securityDeviceId;
return(0,_powerStateData.powerStateDataForDevice)(device);
}},{key:'getStates',value:function getStates()

{
var device=this.securityDeviceId;

return _extends({},
this.getArmStateData(),
this.getHealthStateData(),
this.getComplianceStateData(),
this.getPowerStateData());

}},{key:'getArmDevice',value:function getArmDevice()

{
var device=this.securityDeviceId;

if(device){
return device.getArmDevice();
}

return null;
}},{key:'toString',value:function toString()

{
return'Position: '+this.id;
}}],[{key:'reducer',value:function reducer(action,Position,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_POSITIONS:{var positions=action.payload.positions;positions.forEach(function(p){var position=getIdAndNameForPositionParents(p,session);Position.upsert(position);});break;}case actions.UPDATE_POSITIONS:{var _positions=action.payload.positions;var positionsToRemove=Position.exclude(function(position){return _positions.find(function(_ref){var id=_ref.id;return position.id===id;});});positionsToRemove.toModelArray().forEach(deleteRelatedChilds);positionsToRemove.delete();_positions.forEach(function(p){var positionExists=Position.hasId(p.id);if(positionExists){var _position=Position.withId(p.id);checkRelatedChilds(_position,p);}var position=getIdAndNameForPositionParents(p,session);Position.upsert(position);});break;}case actions.UPDATE_POSITION:{var position=action.payload.position;var positionExists=Position.hasId(position.id);if(positionExists){var oldPosition=Position.withId(position.id);checkRelatedChilds(oldPosition,position);}var p=getIdAndNameForPositionParents(position,session);Position.upsert(p);break;}case actions.DELETE_POSITION:{var id=action.payload.id;Position.hasId(id)&&Position.withId(id).delete();break;}}return undefined;}}]);return Position;}(_reduxOrm.Model);exports.default=Position;

Position.modelName='Position';

Position.fields={
id:(0,_reduxOrm.attr)(),
name:(0,_reduxOrm.attr)(),
price:(0,_reduxOrm.attr)(),
highValue:(0,_reduxOrm.attr)(),
complianceStatus:(0,_reduxOrm.attr)(),
createdAt:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
complianceStatusUpdatedAt:(0,_reduxOrm.attr)(),
noncompliantAt:(0,_reduxOrm.attr)(),
noncompliantNotifiedAt:(0,_reduxOrm.attr)(),
noncompliantReason:(0,_reduxOrm.attr)(),
fixtureId:(0,_reduxOrm.fk)('Fixture','positionIds'),
layoutPositionId:(0,_fields.oneToOne)('PositionLayoutPosition','positionId'),
meta:(0,_reduxOrm.attr)(),
parentId:(0,_reduxOrm.fk)('Position','childIds'),
storeId:(0,_reduxOrm.attr)(),
storeName:(0,_reduxOrm.attr)(),
floorId:(0,_reduxOrm.attr)(),
floorName:(0,_reduxOrm.attr)(),
areaId:(0,_reduxOrm.attr)(),
areaName:(0,_reduxOrm.attr)(),
positionRules:(0,_reduxOrm.attr)(),
securityDevice:(0,_reduxOrm.attr)(),
securedProduct:(0,_reduxOrm.attr)(),
ruleIds:(0,_reduxOrm.many)('Rule'),
rules:(0,_reduxOrm.attr)()};


var upsertPositions=function upsertPositions(positions){
var objs=positions?
positions.map(function(p){
var position=_extends({},
p,{
positionRules:p.positionRuleIds,
securityDevice:p.securityDeviceId,
securedProduct:p.securedProductId,
rules:p.ruleIds});

return(0,_utils.filterInput)(Position)(position);
}):
[];

return{
type:actions.UPSERT_POSITIONS,
payload:{
positions:objs}};


};





var updatePositions=function updatePositions(positions){
var objs=positions?
positions.map(function(p){
var position=_extends({},
p,{
positionRules:p.positionRuleIds,
securityDevice:p.securityDeviceId,
securedProduct:p.securedProductId,
rules:p.ruleIds});

return(0,_utils.filterInput)(Position)(position);
}):
[];

return{
type:actions.UPDATE_POSITIONS,
payload:{
positions:objs}};


};

var updatePosition=function updatePosition(position){
if(!position)return;

var filteredPosition=(0,_utils.filterInput)(Position)(_extends({},
position,{
positionRules:position.positionRuleIds,
securityDevice:position.securityDeviceId,
securedProduct:position.securedProductId,
rules:position.ruleIds}));


return{
type:actions.UPDATE_POSITION,
payload:{
position:filteredPosition}};


};

var deletePositionWithId=function deletePositionWithId(id){return{
type:actions.DELETE_POSITION,
payload:{
id:id}};};



var creators=exports.creators={
upsertPositions:upsertPositions,
updatePositions:updatePositions,
updatePosition:updatePosition,
deletePositionWithId:deletePositionWithId};


var getIdAndNameForPositionParents=function getIdAndNameForPositionParents(position,session){
if(!position.fixtureId){
return position;
}

var fixture=session.Fixture.withId(position.fixtureId);

var store=fixture.storeId;
var floor=fixture.floorId;
var area=fixture.areaId;

var storeId=store?store.id:null;
var storeName=store?store.name:null;

var floorId=floor?floor.id:null;
var floorName=floor?floor.name:null;

var areaId=area?area.id:null;
var areaName=area?area.name:null;

return _extends({},
position,{
storeId:storeId,
storeName:storeName,
floorId:floorId,
floorName:floorName,
areaId:areaId,
areaName:areaName});

};

var checkRelatedChilds=function checkRelatedChilds(oldPosition,newPosition){
checkRelationshipsToPositionRulesAndDeleteOld(oldPosition,newPosition);
checkRelationshipsToRulesAndDeleteOld(oldPosition,newPosition);
checkRelationshipToSecurityDeviceAndDeleteOld(oldPosition,newPosition);
checkRelationshipToSecuredProductAndDeleteOld(oldPosition,newPosition);
};

var checkRelationshipsToPositionRulesAndDeleteOld=function checkRelationshipsToPositionRulesAndDeleteOld(
oldPosition,
newPosition)
{
var existingPositionRulesForPosition=oldPosition.positionRuleIds;
var newPositionRuleIds=newPosition.positionRules;

if(!existingPositionRulesForPosition){
return;
}

if(!newPositionRuleIds){
existingPositionRulesForPosition.delete();
return;
}

existingPositionRulesForPosition.
filter(function(positionRule){return!newPositionRuleIds.includes(positionRule.id);}).
delete();
};

var checkRelationshipsToRulesAndDeleteOld=function checkRelationshipsToRulesAndDeleteOld(oldPosition,newPosition){
var existingRulesForPosition=oldPosition.ruleIds;
var newRuleIds=newPosition.rules;

if(!existingRulesForPosition){
return;
}

if(!newRuleIds){
existingRulesForPosition.delete();
return;
}

existingRulesForPosition.
filter(function(rule){return!newRuleIds.includes(rule.id);}).
delete();
};

var checkRelationshipToSecurityDeviceAndDeleteOld=function checkRelationshipToSecurityDeviceAndDeleteOld(
oldPosition,
newPosition)
{
var existingDevice=oldPosition.securityDeviceId;
var newDevice=newPosition.securityDevice;

if(!existingDevice){
return;
}
if(!newDevice||existingDevice.id!==newDevice.id){
existingDevice.delete();
}
};

var checkRelationshipToSecuredProductAndDeleteOld=function checkRelationshipToSecuredProductAndDeleteOld(
oldPosition,
newPosition)
{
var existingProduct=oldPosition.securedProductId;
var newProduct=newPosition.securedProduct;

if(!existingProduct){
return;
}
if(!newProduct||existingProduct.id!==newProduct.id){
existingProduct.delete();
}
};

var deleteRelatedChilds=function deleteRelatedChilds(position){
position.positionRuleIds&&position.positionRuleIds.delete();
position.securityDeviceId&&position.securityDeviceId.delete();
position.securedProductId&&position.securedProductId.delete();
position.ruleIds&&position.ruleIds.delete();
};